/*
  Darlida 22 Oct 2026: free-gift popup.
  - Product page: clicking the gift row on a quantity tier (.d4-tier__gift[data-d4gp]) or the gift note opens it.
    The tier still gets selected, as before.
  - Cart drawer / cart page: clicking the gift's image or name opens it instead of going to the gift's product page.
  Content lives in snippets/d4-giftpop.liquid (<template id="d4gp-1"> / "d4gp-2").
*/
(function () {
  var dlg = document.getElementById('d4gp');
  if (!dlg || dlg.dataset.ready) return;
  dlg.dataset.ready = '1';
  var body = dlg.querySelector('[data-d4gp-body]');
  var H = { 1: dlg.dataset.h1, 2: dlg.dataset.h2 };
  var last = null;

  function open(n, from) {
    var t = document.getElementById('d4gp-' + n) || document.getElementById('d4gp-1');
    if (!t) return;
    body.innerHTML = '';
    body.appendChild(t.content.cloneNode(true));
    body.scrollTop = 0;
    last = from || document.activeElement;
    if (dlg.open) return;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var x = dlg.querySelector('.d4gp__x');
    if (x) x.focus({ preventScroll: true });
  }
  function close() {
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
  }
  dlg.addEventListener('close', function () {
    if (last && last.focus && document.contains(last)) { try { last.focus({ preventScroll: true }); } catch (e) {} }
  });
  /* Clicks inside the popup are handled here and kept away from the page, so the cart drawer
     does not treat them as an outside click and close. Backdrop clicks land on the dialog itself. */
  window.addEventListener('click', function (e) {
    if (!dlg.open || !dlg.contains(e.target)) return;
    if (e.target === dlg || e.target.closest('[data-d4gp-close]')) close();
    e.stopPropagation();
  }, true);
  /* Escape closes the popup only: swallow the keyup so the cart drawer behind stays open. */
  var esc = false;
  dlg.addEventListener('cancel', function () { esc = true; setTimeout(function () { esc = false; }, 600); });
  window.addEventListener('keyup', function (e) { if (esc && e.key === 'Escape') { esc = false; e.stopPropagation(); } }, true);
  ['mousedown', 'pointerdown', 'touchstart', 'keyup'].forEach(function (ev) {
    window.addEventListener(ev, function (e) { if (dlg.open && dlg.contains(e.target)) e.stopPropagation(); }, { capture: true, passive: true });
  });

  /* Which gift a cart line belongs to, from its "cart-item--product-<handle>" class. */
  function lineGift(el) {
    var li = el.closest('.cart-item');
    if (!li) return 0;
    if (H[2] && li.classList.contains('cart-item--product-' + H[2])) return 2;
    if (H[1] && li.classList.contains('cart-item--product-' + H[1])) return 1;
    return 0;
  }

  /* Tag the product-page gift rows (also after the section re-renders). */
  function tag(root) {
    (root || document).querySelectorAll('.d4-tier__gift:not([data-d4gp])').forEach(function (g) {
      g.setAttribute('data-d4gp', g.classList.contains('d4-tier__gift--big') && H[2] ? '2' : '1');
      if (!g.querySelector('.d4-tier__gmore')) {
        var m = document.createElement('span');
        m.className = 'd4-tier__gmore';
        m.setAttribute('role', 'button');
        m.setAttribute('tabindex', '0');
        m.textContent = "What's inside";
        g.appendChild(m);
      }
    });
    (root || document).querySelectorAll('[data-d4-gift]:not([data-d4gp])').forEach(function (g) { g.setAttribute('data-d4gp', '1'); });
  }
  tag();
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { tag(); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || dlg.contains(t)) return;
    var g = t.closest('[data-d4gp]');
    if (g) {
      /* "What's inside" link: open only. Rest of the gift row: let the tier get selected too. */
      if (t.closest('.d4-tier__gmore')) e.preventDefault();
      open(g.getAttribute('data-d4gp'), g);
      return;
    }
    if (t.closest('.cart-item__media, .cart-item__name')) {
      var n = lineGift(t);
      if (n) { e.preventDefault(); e.stopPropagation(); open(n, t.closest('.cart-item')); }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('d4-tier__gmore')) {
      e.preventDefault();
      var g = e.target.closest('[data-d4gp]');
      if (g) open(g.getAttribute('data-d4gp'), e.target);
    }
  });

  /* The cart drawer traps focus; keep focus events inside the popup away from that trap. */
  window.addEventListener('focusin', function (e) { if (dlg.open && dlg.contains(e.target)) e.stopPropagation(); }, true);

  window.D4GiftPop = { open: open, close: close };
})();
